<template>
  <div class="main-content">
    <div class="h2"><strong>帳戶註冊</strong></div>
    <div class="subtitle">
      已經有帳戶了嗎？
      <a href="#" @click="$store.commit('setLoginCurrentContent', 'login')">登入</a>
    </div>
    <div class="form-div">
      <input type="email" class="form-input" id="register-email" placeholder=" " v-model.lazy="user_info.email">
      <label for="register-email" class="form-label">使用者電子信箱</label>
    </div>
    <div class="form-div">
      <input type="text" class="form-input" id="register-name" placeholder=" " v-model.lazy="user_info.name">
      <label for="register-name" class="form-label">使用者名稱</label>
    </div>
    <div class="form-div">
      <input :type="show_password ? 'text' : 'password'" class="form-input" id="register-password" placeholder=" "
        v-model.lazy="user_info.password">
      <label for="register-password" class="form-label">登錄密碼</label>
      <div type="button" class="switch-password" v-show="show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye-slash"></i>
      </div>
      <div type="button" class="switch-password" v-show="!show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye"></i>
      </div>
    </div>
    <div class="form-div">
      <input :type="show_password ? 'text' : 'password'" class="form-input" id="confirmation-password" placeholder=" "
        v-model.lazy="user_info.password_confirmation">
      <label for="confirmation-password" class="form-label">確認密碼</label>
      <div type="button" class="switch-password" v-show="show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye-slash"></i>
      </div>
      <div type="button" class="switch-password" v-show="!show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye"></i>
      </div>
    </div>
    <div class="send-bag">
      <button class="form-button bg-success" @click="userRegister">新用戶註冊</button>
    </div>
    <div class="form-check">
      <input type="checkbox" name="user-agree" id="user-agree" class="form-check-input">
      <label for="user-agree" class="form-check-label">我已閱讀並接受使用者條款和隱私權政策。</label>
    </div>
    <hr>
    <copyright-component></copyright-component>
  </div>
</template>

<script>
import CopyrightComponent from '../layouts/CopyrightComponent.vue';
import { validation } from '../mixins/validation.js';
import { axiosMixins } from '../mixins/axiosErrorMessage.js';

export default {
  mixins: [validation, axiosMixins],
  data() {
    return {
      user_info: {
        email: '',
        name: '',
        password: '',
        password_confirmation: ''
      },
      show_password: false
    }
  },
  methods: {
    userRegister() {
      if (!this.validateBeforeSubmit()) { return }
      const axios_data = {
        email: this.user_info.email,
        name: this.user_info.name,
        password: this.user_info.password,
        password_confirmation: this.user_info.password_confirmation,
        bx_only: true
      };
      axios.post(base_url + '/api/register', axios_data)
        .then((response) => {
          window.axios.defaults.headers["Authorization"] = "Bearer " + response.data.token
          const user = {
          id: response.data.id,
          name: response.data.name,
          email: response.data.email,
        };
        localStorage.setItem('token', "Bearer " + response.data.token);
        localStorage.setItem('user_info', JSON.stringify(user));
          this.$store.commit('setVerifyAccount', this.user_info.email);
          this.$store.commit('setLoginCurrentContent', 'verification-email');
        }).catch((error) => {
          this.axiosMessage(error);
          const error_element = this.$el.querySelector('#error-password')
          error_element.innerHTML = "註冊失敗";
          setTimeout(() => {
            error_element.innerHTML = "";
          }, 3000);
        });
    },
  },
  components: { CopyrightComponent },
}
</script>

<style scoped>
.form-check {
  color: gray;
  width: 95%;
  margin-top: 1rem;
  font-size: 0.8rem;

  >.form-check-input {
    margin-top: 0.1rem;
    margin-left: -1rem;
  }

  >.form-check-input.is-invalid~.form-check-label {
    color: gray;
  }
}
</style>
